/*global SPiD*/

SPiD.agreementNavigation = (function() {
    'use strict';
    var agreementContainer,
        termsSubmenu,
        mobileTermsSubmenu,
        parts = [],
        navigation,
        distanceTop,
        headers;

    var addSubheadersToNav = function() {
        for (var i = 0; i < headers.length; i++) {
            var paragraphNr = i + 1;
            termsSubmenu.innerHTML += '<li class="second-level-item"><a class="nav-link" href="#part-' + paragraphNr + '">' + headers[i].textContent + '</a></li>';
            mobileTermsSubmenu.innerHTML += '<li class="second-level-item"><a class="nav-link" href="#part-' + paragraphNr + '">' + headers[i].textContent + '</a></li>';
            headers[i].setAttribute('id', 'part-' + paragraphNr);
        }
    };

    var findSubheaderPosition = function() {
        parts = [];
        for (var i = 0; i < headers.length; i++) {
            parts.push(headers[i].getBoundingClientRect().top + window.scrollY - 10);
        }
    };

    var markSubMenu = function() {
        var mark = 0,
            navLinks = termsSubmenu.getElementsByClassName('nav-link'),
            i;

        for (i = 0; i < parts.length; i++) {
            if (window.scrollY > parts[i]) {
                mark = i;
            }
        }

        for (i = 0; i < navLinks.length; i++) {
            if (i === mark) {
                navLinks[i].className = 'nav-link active';
            } else {
                navLinks[i].className = 'nav-link';
            }
        }
    };

    var onScrollAction = function() {
        if (window.scrollY >= distanceTop) {
            navigation.className = 'sticky';
        } else {
            navigation.className = '';
        }

        markSubMenu();
    };

    var getNavigationInitialPosition = function() {
        if (window.innerWidth > 700) {
            var currentClass = navigation.className;
            navigation.className = '';
            distanceTop = navigation.getBoundingClientRect().top + window.scrollY - 10;
            navigation.className = currentClass;
            onScrollAction();
        }
    };

    var getPositions = function() {
        getNavigationInitialPosition();

        findSubheaderPosition();
    };

    var mobileNavigationIconClick = function() {
        var parent = document.getElementsByClassName('mobile-agreement-navigation-icon-container')[0],
            mobileNavigation = document.getElementById('mobile-agreement-navigation');

        if (parent.className.indexOf(' active') > -1) {
            parent.className = parent.className.replace(' active', '');
            mobileNavigation.className = mobileNavigation.className.replace(' active', '');
            document.removeEventListener('click', mobileNavigationIconClick);
        } else {
            parent.className += ' active';
            mobileNavigation.className += ' active';
            window.setTimeout(function () {
                document.addEventListener('click', mobileNavigationIconClick);
            }, 100);
        }
    };

    var mobileNavigationLinkClick = function() {
        mobileNavigationIconClick();

        window.setTimeout(function () {
            window.scrollBy(0, -66);
        }, 100);
    };

    return function() {
        agreementContainer = document.querySelector('[data-js="agreementContainer"]');
        if (agreementContainer===null) {
            return;
        }

        navigation = document.getElementById('agreement-navigation');
        termsSubmenu = document.getElementById('terms-submenu');
        mobileTermsSubmenu = document.getElementById('mobile-terms-submenu');
        distanceTop = navigation.getBoundingClientRect().top + window.scrollY - 10;
        headers = agreementContainer.getElementsByTagName('h2');

        addSubheadersToNav();

        getPositions();

        onScrollAction();

        document.getElementById('mobile-agreement-navigation-icon').addEventListener('click', mobileNavigationIconClick);

        document.getElementById('mobile-agreement-navigation').addEventListener('click', mobileNavigationLinkClick);

        document.onscroll = onScrollAction;

        window.addEventListener('resize', getPositions);
    };
}());
